module.exports = __webpack_public_path__ + "static/img/14002015.e963991f.png";